import { RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { CommonModule, NgOptimizedImage } from '@angular/common';
import { LoaderIndicatorComponent } from './components/loading-indicator/loading-indicator.component';
import { HeaderComponent } from './components/header/header.component';
import { TopbarComponent } from './components/topbar/topbar.component';
import { FooterComponent } from './components/footer/footer.component';
import { InViewModule } from '@teamfoster/sdk/in-view';
import { TextUtilityModule } from '@teamfoster/sdk/text-utility';
import { GridOverlayComponent } from './components/grid-overlay/grid-overlay.component';
import { IconComponent } from './components/icon/icon.component';
import { ImageComponent } from './components/image/image.component';
import { HighlightPipe } from './pipes/highlight.pipe';
import { DictionaryNgrxModule } from '@teamfoster/sdk/dictionary-ngrx';
import { BreadcrumbsComponent } from './components/breadcrumbs/breadcrumbs.component';
import { HeaderArticleComponent } from './components/header-article/header-article.component';
import { SearchBarComponent } from './components/search-bar/search-bar.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SearchResultsComponent } from './components/search-results/search-results.component';
import { AlertComponent } from './components/alert/alert.component';
import { DialogConfirmComponent } from './components/dialog-confirm/dialog-confirm.component';
import { MatDialogModule } from '@angular/material/dialog';
import { LangSwitcherComponent } from './components/lang-switcher/lang-switcher.component';
import { DynamicFormModule } from '@teamfoster/dynamic-forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { HoverDelayDirective } from './directives/hover-delay.directive';
import { ImageModule } from '@teamfoster/sdk/image';
import { ButtonModule } from '@teamfoster/sdk/button';
import { FromMenuPipe, GetMenuPipe, OfMenuTypePipe } from '@teamfoster/sdk/menu-ngrx';

const moduleExports = [
  LoaderIndicatorComponent,
  HeaderComponent,
  TopbarComponent,
  FooterComponent,
  GridOverlayComponent,
  IconComponent,
  ImageComponent,
  HighlightPipe,
  BreadcrumbsComponent,
  BreadcrumbsComponent,
  HeaderArticleComponent,
  AlertComponent,
  DialogConfirmComponent,
  LangSwitcherComponent,
  HoverDelayDirective,
];

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    InViewModule,
    TextUtilityModule,
    DictionaryNgrxModule,
    FormsModule,
    ReactiveFormsModule,
    MatDialogModule,
    DynamicFormModule,
    MatFormFieldModule,
    ImageModule,
    ButtonModule,
    OfMenuTypePipe,
    NgOptimizedImage,
  ],
  declarations: [...moduleExports, SearchBarComponent, SearchResultsComponent],
  exports: [...moduleExports],
  providers: [],
})
export class CoreModule {}
